The contextual name of the location, e.g. "Richmond VIC 3121 AU".

This name is sufficient to unambiguously identify the location to a hirer.
